import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: 'ach',
        data: {
            title: 'ACH',
        },
        loadChildren: () =>
            import('./features/ach-enrollment/ach-enrollment.module').then(
                (m) => m.AchEnrollmentModule
            ),
    },
    {
        path: 'dpp',
        data: {
            title: 'Stripe',
        },
        loadChildren: () =>
            import('./features/dpp-enrollment/dpp-enrollment.module').then(
                (m) => m.DppEnrollmentModule
            ),
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'ach',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
